let requested = false;

// Loading this tiny chunk makes webpack emit <link rel="prefetch"> for the
// maplibre chunks it references (see mapPrefetch.js) — nothing executes.
const loadPrefetchChunk = () =>
  import(/* webpackChunkName: "map-prefetch" */ './mapPrefetch');

/**
 * Warm the browser cache with the maplibre chunks before the user opens the
 * swap list, whose route chunk group includes them. Desktop only: on mobile
 * the ~270 KB would be wasted data for users who never open the map, and the
 * swap list route loads them itself anyway.
 */
export function prefetchMapVendor({ isMobile }, load = loadPrefetchChunk) {
  if (requested || isMobile) return false;
  requested = true;

  const run = () =>
    load().catch(() => {
      requested = false;
    });
  if (typeof window !== 'undefined' && window.requestIdleCallback) {
    window.requestIdleCallback(run, { timeout: 5000 });
  } else {
    setTimeout(run, 1000);
  }
  return true;
}
